import React from 'react';

import { Container, LeftColumn, RightColumn } from '@components/AuthLayout/styles';

function AcceptLayout({ children }) {
  return (
    <Container>
      <LeftColumn />
      <RightColumn className="auth-layout">{children}</RightColumn>
    </Container>
  );
}

export default AcceptLayout;
